"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var director_1 = require("director/build/director");
var mobx_1 = require("mobx");
var utils_1 = require("./utils");
var createDirectorRouter = function (views, store, config) {
    if (config === void 0) { config = {}; }
    new director_1.Router(__assign({}, utils_1.viewsForDirector(views, store, config)))
        .configure(config)
        // set fallback to /#/ only when hash routing
        .init(config.html5history === false ? '/' : undefined);
};
exports.startRouter = function (routes, store, config) {
    if (config === void 0) { config = {}; }
    //create director configuration
    var defaultDirectorConfig = {
        html5history: true,
    };
    var directorConfig = Object.assign(defaultDirectorConfig, config);
    createDirectorRouter(routes, store, directorConfig);
    //autorun and watch for path changes
    mobx_1.autorun(function () {
        var currentPath = store.router.currentPath;
        if (currentPath) {
            if (directorConfig.html5history) {
                if (currentPath !== (window.location.pathname + window.location.search)) {
                    window.history.pushState(null, null || "", currentPath);
                }
            }
            else {
                var hash = "#" + currentPath;
                if (hash !== window.location.hash) {
                    window.history.pushState(null, null || "", "/" + hash);
                }
            }
        }
    });
};
//# sourceMappingURL=start-router.js.map